"use client";
import SectionWrapper from "@cc/section-wrapper";
import { Body1, H3, H6_2 } from "@theme/components/typography.fontvariant";
import { StaticImageData } from "next/image";
import { Stack, Typography } from "@mui/material";
import { MaterialImage } from "@cc/material-components";

export interface EconomicDevelopmentProps {
  data: {
    title: string;
    description: string;
    developmentData: {
      title: string;
      description: string;
      image: string | StaticImageData;
    }[];
  };
  navId?: string;
}

const EconomicDevelopment = (props: EconomicDevelopmentProps) => {
  const { data, navId } = props;
  const { title, description, developmentData } = data;
  return (
    <SectionWrapper
      navId={navId || "Economic-development"}
      SectionProps={{
        id: "economic-development",
      }}
      SectionHeaderProps={{
        title,
        TitleTypographyProps: {
          fontSize: H3,
          color: "primary.main",
        },
        description,
        DescriptionTypographyProps: {
          fontSize: Body1,
          color: "grey.600",
          maxWidth: 865,
        },
      }}
      direction={{ xs: "column", xl: "row" }}
      spacing={{ xs: 0, xl: 3 }}
      rowGap={5}
    >
      {developmentData.map((item, index) => {
        const { title, description, image } = item;
        return (
          <Stack
            key={`${title}-${index}`}
            direction={{ xs: "column", sm: "row" }}
            width={{ xs: 1, xl: 0.5 }}
            spacing={{ xs: 0, sm: 2 }}
            rowGap={2}
          >
            <MaterialImage
              src={image}
              alt={title}
              sx={{
                width: { xs: "100%", sm: 156 },
                height: { xs: 143, sm: "100%" },
                objectFit: "cover",
              }}
            />
            <Stack rowGap={{ xs: 1, sm: 2 }}>
              <Typography
                component={"h2"}
                fontSize={H6_2}
                sx={{ color: "primary.main" }}
              >
                {title}
              </Typography>
              <Typography variant={"body1"} sx={{ color: "grey.600" }}>
                {description}
              </Typography>
            </Stack>
          </Stack>
        );
      })}
    </SectionWrapper>
  );
};

export default EconomicDevelopment;
